// extracted by mini-css-extract-plugin
export default {"Form":"fVKJUeWs8WqXbDkkdpad","Heading":"wirJD1reSdf8A0CKwx05","ProgressContainer":"HpTtM0zIH1kpx_qylWA8","StatusIcon":"Ei9JlgViMXIos6211fSd"};